var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 34.5C33.1046 34.5 34 33.6046 34 32.5C34 31.3954 33.1046 30.5 32 30.5C30.8954 30.5 30 31.3954 30 32.5C30 33.6046 30.8954 34.5 32 34.5Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 34.5C23.1046 34.5 24 33.6046 24 32.5C24 31.3954 23.1046 30.5 22 30.5C20.8954 30.5 20 31.3954 20 32.5C20 33.6046 20.8954 34.5 22 34.5Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34.5C43.1046 34.5 44 33.6046 44 32.5C44 31.3954 43.1046 30.5 42 30.5C40.8954 30.5 40 31.3954 40 32.5C40 33.6046 40.8954 34.5 42 34.5Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9822 53.2776C25.0235 56.1953 30.9539 57.18 36.6676 56.0482C42.3814 54.9164 47.4885 51.7452 51.0369 47.126C54.5852 42.5067 56.3326 36.7547 55.9531 30.9423C55.5737 25.1299 53.0934 19.6538 48.9747 15.5351C44.8559 11.4163 39.3799 8.93604 33.5675 8.55662C27.7551 8.17719 22.003 9.92454 17.3838 13.4729C12.7646 17.0212 9.5934 22.1284 8.46156 27.8421C7.32973 33.5559 8.31446 39.4862 11.2322 44.5276L8.10468 53.8651C7.98716 54.2175 7.9701 54.5956 8.05542 54.9572C8.14074 55.3187 8.32507 55.6493 8.58774 55.912C8.85041 56.1747 9.18104 56.359 9.54258 56.4443C9.90413 56.5296 10.2823 56.5126 10.6347 56.3951L19.9822 53.2776Z",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChat);
export default __webpack_public_path__ + "static/media/empty-chat.75b9eca0e68fb5378e35498980f5a634.svg";
export { ForwardRef as ReactComponent };